











































import { Component, Vue } from "vue-property-decorator";
import { checkEditorProfileUsage, deleteEditorProfile } from "@/services/editorProfiles/editorProfilesService";
import { EditorProfile } from "@/services/editorProfiles/types";

    @Component
export default class EditorProfileDeleteModal extends Vue {
        // local state
        editorProfileDelete = {} as EditorProfile;
        isSaved: boolean = false;

        handleEnter(e: KeyboardEvent) {
            if (e.key === "Enter") this.confirmDelete();
        }

        removeEvent() {
            window.removeEventListener("keydown", this.handleEnter);
            this.isSaved = false;
        }

        // methods
        open(editorProfile: EditorProfile) {
            checkEditorProfileUsage(editorProfile.id).then(response => {
                if (response) this.$bvModal.show("modal-deleteEditorProfileInUse");
                else {
                    this.editorProfileDelete = editorProfile;
                    this.$bvModal.show("modal-deleteEditorProfile");
                }

                window.addEventListener("keydown", this.handleEnter);
            });
        }

        declineDelete() {
            this.$bvModal.hide("modal-deleteEditorProfile");
            this.editorProfileDelete = {} as EditorProfile;
        }

        confirmDelete() {
            if (this.isSaved) return;
            this.isSaved = true;

            if (!this.editorProfileDelete.id) {
                this.$bvModal.hide("modal-deleteEditorProfileInUse");
                return;
            }

            deleteEditorProfile(this.editorProfileDelete.id).then(() => {
                this.editorProfileDelete = {} as EditorProfile;
                this.$emit("reload");
                this.$bvModal.hide("modal-deleteEditorProfile");
            });
        }
}
